import React from 'react'

function Widget({ vencidas, vencendo, aberta, tickets }) {

    return (
        <>
            <div className="col-md-4">
                <div className="card crm-data-card">
                    <div className="card-body">
                        <div className="row align-items-center">
                            <div className="col-4">
                                <div className="data-icon">
                                    <i className="ti-clipboard rounded-circle bg-soft-danger"></i>
                                </div>
                            </div>
                            <div className="col-8">
                                <h3>{vencidas}</h3>
                                <p className="label-subtitle">Condicionantes e Licenças</p>
                                <p className="label-main">Vencidas</p>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <div className="col-md-4">
                <div className="card crm-data-card">
                    <div className="card-body">
                        <div className="row align-items-center">
                            <div className="col-4">
                                <div className="data-icon ">
                                    <i className="ti-receipt rounded-circle bg-soft-success"></i>
                                </div>
                            </div>
                            <div className="col-8">
                                <h3>{vencendo}</h3>
                                <p className="label-subtitle">Condicionantes e Licenças</p>
                                <p className="label-main">Vencendo/mês</p>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <div className="col-md-4">
                <div className="card crm-data-card">
                    <div className="card-body">
                        <div className="row align-items-center">
                            <div className="col-4">
                                <div className="data-icon">
                                    <i className="ti-agenda rounded-circle bg-soft-info"></i>
                                </div>
                            </div>
                            <div className="col-8">
                                <h3>{aberta}</h3>
                                <p className="label-subtitle">Condicionantes e Licenças</p>
                                <p className="label-main">Em Aberto</p>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            {/* <div className="col-md-3">
                <div className="card crm-data-card">
                    <div className="card-body">
                        <div className="row align-items-center">
                            <div className="col-4">
                                <div className="data-icon">
                                    <i className="ti-comments rounded-circle bg-soft-warning"></i>
                                </div>
                            </div>
                            <div className="col-8">
                                <h3>{tickets}</h3>
                                <p className="label-subtitle">Tickets Abertos</p>
                                <p className="label-main">Tickets</p>
                            </div>
                        </div>
                    </div>
                </div>
            </div> */}
        </>
    )
}

export default React.memo(Widget)